<template>
  <v-form ref="form" @submit.prevent="submit" class="containerStepRisk2">
    <v-row class="buttonBack">
      <QuotationBackButton
        v-if="currentQuotation.cancelada_em == null"
        @back="previousStep"
      />
      <v-spacer />
    </v-row>
    <v-row>
      <v-spacer />
      <QuotationFloatActionButton
        class="messageInfoRisk2"
        v-if="!getIsEmployeeUser"
        :message="infoMessage"
      />
    </v-row>
    <QuotationRiskForm2
      @submit="submit"
      @cancel="cancelQuotationButton"
      v-model="formRisk2"
      :formRisk2="formRisk2"
      :options-quotation="optionsQuotation"
      :formInsured="formInsured"
      :formLocation="formLocation"
    />
    <BaseFooter v-if="currentQuotation.cancelada_em == null">
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="5" md="3" class="pr-0 pr-sm-5 pb-5 pb-sm-0">
          <BaseButton
            v-html="'CANCELAR SOLICITAÇÃO'"
            class="white--text pink"
            width="100%"
            @click="cancelQuotation"
          />
        </v-col>
        <v-col cols="12" sm="5" md="3">
          <BaseButton
            v-html="'PRÓXIMO'"
            class="white--text secondary"
            width="100%"
            @click="submit()"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </v-form>
</template>
<script>
import QuotationRiskForm2 from "../components_agro/QuotationRiskForm2.vue";
import QuotationBackButton from "../components_agro/QuotationBackButton";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
import { mapState } from "vuex";
import QuotationFloatActionButton from "../components_agro/QuotationFloatActionButton.vue";

export default {
  name: "QuotationStepRisk2",
  data: () => ({
    formRisk2: {}
  }),
  components: {
    QuotationRiskForm2,
    QuotationBackButton,
    QuotationFloatActionButton
  },
  mixins: [QuotationMixin],
  computed: {
    ...mapState("quotation", ["currentQuotation"]),
    ...mapState("me", ["userIsEmployee"]),
    validFormAreas() {
      return this.formRisk2.areas.find(item => item.logradouro == null) == null;
    },
    nextQuotationStep() {
      return {
        name: "quotation step proposal",
        step: 8
      };
    },
    previousQuotationStep() {
      return {
        name: "quotation step insured2",
        step: 6
      };
    },
    getIsEmployeeUser() {
      return this.userIsEmployee;
    },
    infoMessage() {
      return "Na tabela Áreas Cadastradas, clique no botão de Lápis, ao lado de cada área “Pendente”, para preencher o endereço completo de cada área. ";
    }
  },
  created() {
    this.formRisk2 = this.form;
  },
  methods: {
    getFormForNavigation() {
      return this.formRisk2;
    },
    submit() {
      if (this.validFormAreas) {
        this.$emit(
          "updateStep",
          this.payloadQuotation(this.formRisk2, this.nextQuotationStep)
        );
      } else {
        this.showAlertNotification({
          message: "Edite as áreas Pendentes para prosseguir.",
          type: "error"
        });
        return;
      }
    },
    cancelQuotation() {
      this.$emit("cancel");
    },
    previousStep() {
      this.$emit(
        "updateStep",
        this.payloadQuotation(this.formRisk2, this.previousQuotationStep)
      );
    }
  },
  props: {
    form: {
      type: Object
    },
    readonlyForm: {
      type: Object
    },
    optionsQuotation: {
      type: Object
    },
    formInsured: {
      type: Object
    },
    formLocation: {
      type: Object
    }
  }
};
</script>
<style lang="sass">
.containerStepRisk2
  display: flex
  flex-direction: column
  justify-content: center
  width: 95% !important
  margin: 0 auto !important
  align-self: center !important
.buttonBack
  margin-top: -40px
  margin-bottom: 8px
.messageInfoRisk2
  margin-top: -48px
  margin-right: 80px
</style>
